import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { GlobalService } from '../global.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-servicesandequipment',
  templateUrl: './servicesandequipment.component.html',
  styleUrls: ['./servicesandequipment.component.sass']
})

export class ServicesandEquipmentComponent implements OnInit {
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public expand = [];
  public SubscriberInfo = [];
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;
  paymentReceived: Subscription;
  public info = [];
  public selTab: number;
  public cycleDateField;
  public tabActive='Mis Equipos y Servicios';
  public selectBan;
  public banlist;
  public subscribernumber;

  constructor(private router: Router, public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, public global:GlobalService, private route: ActivatedRoute, public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Mis Equipos y Servicios");
    this.AngularFireAnalytics.logEvent("Mis Equipos y Servicios-Screenview");
   }
  ngOnInit() {
    if (this.global.sessionReview() == true) {
      this.expand[0] = true;
      this.selTab = 1;
      this.getId();
      this.banlist=JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
      this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
      this.subscribernumber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.subscriberNumberField;
      this.global.mask(this.subscribernumber);
      this.loadingScreenService.stopLoading();
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value);
      });
      this.paymentReceived = this.global.rechargeReceived.subscribe((value: string) => {
        this.global.notif("He verificado su pago exitoso, número de autorización : "+value[0]+" , número de referencia : "+value[1]+" .");
        this.initializeData();
      });
    }
  }
  refreshDataTo() {
    if(this.global.validateSession()===true){
      let index = parseInt(event.target["selectedIndex"]);
      let ban = this.currentList[index].account;
      sessionStorage.setItem("selectBan", btoa(ban));
      this.initializeData();
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw) {
    if (this.postpago == true) {
      this.type = "postpaid";
    }
    else if (this.prepago == true) {
      this.type = "prepaid";
    }
    else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.expand[0] = true;
    this.selTab = 1;
    this.getId();
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.global.mask(this.subscribernumber);
    this.loadingScreenService.stopLoading();
  }
  updateExpand(index) {
    this.expand[index] = !this.expand[index];
  }
  statusChange(sw) {
    this.global.validateSession();
    this.selTab = sw;
  }
  getId() {
    if (this.route.firstChild) {
      var id = this.route.firstChild.snapshot.params.id;
      if (id == '1') {
        this.selTab = 1;
      }
      else if (id == '2') {
        this.selTab = 2;
      }
      else {
        this.selTab = 1;
        this.router.navigate(['usage']);
      }
    }
  }
  ngOnDestroy() {
    this.loadObserver.unsubscribe();
    this.paymentReceived.unsubscribe();
  } 
}